// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IWebHistoryMessagesRequest,
  TWebHistoryMessagesModel,
  IMappers,
  TWebHistoryMessagesResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IMessagesHistoryResponseSchema } from '../../../../entities/history/MessagesHistoryResponseSchema';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createWebHistoryMessagesModel(parameters: IWebHistoryMessagesRequest): TWebHistoryMessagesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v2/web/history/messages/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IWebHistoryMessagesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IWebHistoryMessagesRequest;
}

export async function fetchWebHistoryMessages<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebHistoryMessagesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebHistoryMessagesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebHistoryMessagesModel(parameters),
    config,
  )) as FetchResponse<TWebHistoryMessagesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMessagesHistoryResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebHistoryMessagesResponse>;
}
